import React from "react";
import PropTypes from "prop-types";
//
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import makeStyles from "@mui/styles/makeStyles";
//
import HelpGuide from "../help-guide/HelpGuide";
import { useHelpPanel } from "../../hooks/help-panel/HelpPanelHook";
import { useTranslation } from "@limitless/common/hooks";
import Close from "@limitless/icons/Times";
import SwapLeftIcon from "@limitless/icons/LeftArrowToLeft";
import SwapRightIcon from "@limitless/icons/ArrowToRight";
const useStyles = makeStyles(theme => ({
  drawerContainer: {
    top: 69,
    bottom: 0,
    height: "100%",
    width: 350,
    zIndex: 1199
  },
  helpHeader: {
    marginLeft: 16,
    marginTop: 12,
    zIndex: 0
  },
  iconButton: {
    color: theme.palette.primary.dark
  },
  templateCols: {
    height: "calc(100vh - 75px)",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr 45px",
    gridTemplateAreas: `"main"
                            "footer"`
  },
  mainContainer: {
    zIndex: 1,
    gridArea: "main",
    overflow: "auto",
    paddingTop: 20
  },
  closeContainer: {
    gridArea: "footer",
    display: "block",
    width: "100%",
    textAlign: "center"
  },
  closeButton: {
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.03)"
    },
    fontWeight: 400
  }
}));
const HelpPanel = ({
  showHelp,
  setShowHelp
}) => {
  const [anchor, setAnchor] = React.useState("right");
  const classes = useStyles({
    anchor
  });
  const {
    guideConfig,
    updateActivePage
  } = useHelpPanel();
  const {
    t
  } = useTranslation();
  const renderGuide = () => {
    var _guideConfig$guide;
    return /*#__PURE__*/React.createElement(HelpGuide, {
      guideHook: {
        guideConfig,
        updateActivePage
      },
      sections: (_guideConfig$guide = guideConfig.guide) === null || _guideConfig$guide === void 0 ? void 0 : _guideConfig$guide.sections,
      t: t
    });
  };
  const switchSide = () => {
    setAnchor(anchor === "right" ? "left" : "right");
  };
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: anchor,
    open: showHelp,
    onClose: setShowHelp,
    classes: {
      paper: classes.drawerContainer
    },
    variant: "persistent"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.templateCols
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    id: "cont-1",
    className: classes.mainContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    id: "cont-2"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    id: "cont-3",
    style: {
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary",
    className: classes.helpHeader
  }, t("Limitless Guide"))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    justifyContent: "flex-end",
    xs: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: switchSide,
    className: classes.iconButton,
    size: "large"
  }, anchor === "right" ? /*#__PURE__*/React.createElement(SwapLeftIcon, {
    sx: {
      color: theme => theme.palette.grey[600]
    }
  }) : /*#__PURE__*/React.createElement(SwapRightIcon, {
    sx: {
      color: theme => theme.palette.grey[600]
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: setShowHelp,
    className: classes.iconButton,
    size: "large"
  }, /*#__PURE__*/React.createElement(Close, {
    sx: {
      color: theme => theme.palette.grey[600]
    }
  })))))), !guideConfig.loading && renderGuide()), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.closeContainer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: setShowHelp,
    className: classes.closeButton
  }, t("Close Guide"))))));
};
HelpPanel.propTypes = {
  showHelp: PropTypes.bool,
  setShowHelp: PropTypes.func
};
export default HelpPanel;